import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const TeamCollaboration: React.FC = () => {
  return (
    <PageTemplate
      title="Team Collaboration"
      description="Collaborate with your team members"
    />
  );
};

export default TeamCollaboration;